import { Badge, BadgeProps, Tooltip } from "@mantine/core";
import { useTranslation } from "react-i18next";
import type { DeliveryOrderType, DeliverySource } from "../../../models/DeliveryNote";

interface Props {
  orderType?: DeliveryOrderType | null;
  source?: DeliverySource | null;
  size?: BadgeProps["size"];
  variant?: BadgeProps["variant"];
}

const TYPE_COLOR: Record<DeliveryOrderType, BadgeProps["color"]> = {
  REGULAR                  : "gray",
  CONSIGNMENT_INITIAL      : "teal",
  CONSIGNMENT_REPLENISHMENT: "blue",
  CONSIGNMENT_RETURN       : "orange",
  CONSIGNMENT_TRANSFER     : "violet",
};

export function OrderTypeBadge({
  orderType,
  source,
  size = "sm",
  variant = "light",
}: Props) {
  const { t } = useTranslation("delivery");
  const type: DeliveryOrderType = orderType ?? "REGULAR";

  const badge = (
    <Badge size={size} variant={variant} color={TYPE_COLOR[type]}>
      {t(`badges.orderType.${type}`)}
    </Badge>
  );

  if (source && type !== "REGULAR") {
    return <Tooltip label={t(`badges.source.${source}`)}>{badge}</Tooltip>;
  }
  return badge;
}
